<template>
    <p>Panier : {{nbItmesInCart}}</p>
</template>

<script>
    export default {
        name: "CartCount",
        props:{
            nbItmesInCart:Number,
        }
    }
</script>

<style scoped>

</style>